import React from 'react';
import { getEnv } from '../../environment/resolve';
const LicenseTooltip = ({
  title
}) => {
  const {
    salesEmail
  } = getEnv();
  return <div style={{
    maxWidth: 350
  }} data-sentry-component="LicenseTooltip" data-sentry-source-file="LicenseTooltip.jsx">
      <strong>{title}</strong> is not included in your license. <br /> Contact{' '}
      <a href={`mailto:${salesEmail}`}>{salesEmail}</a> for access.
    </div>;
};
export default LicenseTooltip;